import actionNames from './actionNames'

const mutations = {
  user(state, user) {
    state.user = user
  },
  self(state, self) {
    state.self = self
  },

  [actionNames.AUTO_AUTH_COMPLETE]: (state) => {
    state.isAutoAuthing = false
  },
  [actionNames.AUTH_CHECK_REQUESTED]: (state) => {
    state.isAutoAuthing = true
    state.isAuthCheckRequested = true
  },

  [actionNames.SET_ALIAS_MODE_REQUESTED](state) {
    state.isLoadingAliasMode = true
    state.didAliasModeFail = false
  },
  [actionNames.SET_ALIAS_MODE_SUCCEEDED](state) {
    state.isLoadingAliasMode = false
    state.didAliasModeFail = false
  },
  [actionNames.SET_ALIAS_MODE_FAILED](state, error) {
    state.isLoadingAliasMode = false
    state.didAliasModeFail = error || true
  },

  aliasOptions(state, aliasOptions) {
    state.aliasOptions = aliasOptions
  },

  [actionNames.SET_DEMO_MODE_REQUESTED](state) {
    state.isLoadingDemoMode = true
    state.didDemoModeFail = false
  },
  [actionNames.SET_DEMO_MODE_SUCCEEDED](state, demoMode) {
    state.isLoadingDemoMode = false
    state.didDemoModeFail = false

    state.demoMode = demoMode
  },
  [actionNames.SET_DEMO_MODE_FAILED](state, error) {
    state.isLoadingDemoMode = false
    state.didDemoModeFail = error || true
  },

  [actionNames.SET_DEV_MODE_REQUESTED](state) {
    state.isLoadingDevMode = true
    state.didDevModeFail = false
  },
  [actionNames.SET_DEV_MODE_SUCCEEDED](state) {
    state.isLoadingDevMode = false
    state.didDevModeFail = false
  },
  [actionNames.SET_DEV_MODE_FAILED](state, error) {
    state.isLoadingDevMode = false
    state.didDevModeFail = error || true
  },

  [actionNames.SIGN_IN_REQUESTED]: (state, email) => {
    state.isSigningIn = email
    state.didSignInFail = false
  },
  [actionNames.SIGN_IN_SUCCEEDED]: (state) => {
    state.isSignedOut = false
    state.isSigningIn = false
    state.didSignInFail = false
    state.isAutoAuthing = false
  },
  [actionNames.SIGN_IN_FAILED]: (state, error) => {
    state.isSigningIn = false
    state.didSignInFail = error
    state.isAutoAuthing = false
  },

  [actionNames.SIGN_OUT_REQUESTED]: (state) => {
    state.isSigningOut = true
  },
  [actionNames.SIGN_OUT_SUCCEEDED]: (state) => {
    state.isSigningOut = false
    state.isSignedOut = true

    state.firebaseAuthUser = null
    state.firestoreUser = null
    state.googleProfile = null
    state.person = null
    state.user = null
  },
  [actionNames.SIGN_OUT_FAILED]: (state) => {
    state.isSigningOut = false
  },

  [actionNames.SHOW_HELP](state, isShowingHelp) {
    state.isShowingHelp = isShowingHelp
  },
  isShowingHelp(state, isShowingHelp) {
    state.isShowingHelp = isShowingHelp
  },

  demoMode(state, demoMode) {
    state.demoMode = demoMode
  },
  confirmDemoModeChange(state, confirmDemoModeChange) {
    state.confirmDemoModeChange = confirmDemoModeChange
  },
  errorDemoModeChange(state, errorDemoModeChange) {
    state.errorDemoModeChange = errorDemoModeChange
  },
  inputDemoMode(state, inputDemoMode) {
    state.inputDemoMode = inputDemoMode
  },
  inputDemoModeChange(state, inputDemoModeChange) {
    state.inputDemoModeChange = inputDemoModeChange
  },

  fnUnwatchReport(state, { docId, fnUnwatch }) {
    state.fnUnwatchReport[docId] = fnUnwatch
  },
  fnUnwatchUser(state, fnUnwatchUser) {
    state.fnUnwatchUser = fnUnwatchUser
  },

  firebaseAuthUser(state, firebaseAuthUser) {
    state.firebaseAuthUser = firebaseAuthUser
  },
  firestoreUser(state, firestoreUser) {
    state.firestoreUser = firestoreUser
  },
  googleProfile(state, googleProfile) {
    state.googleProfile = googleProfile
  },
  person(state, person) {
    state.person = person
  },

  reports(state, reports) {
    state.reports = reports
  },
}

export default mutations
